var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#092b4a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m766.67-69.67 124.33-125L858.67-226 790-157.33V-317h-45.67v159.67L674.67-226l-31.34 31.33 123.34 125ZM480-804 248.33-670.33 480-535.67l231.67-134.66L480-804ZM92-319.33v-321.34q0-27.72 13.58-52.05 13.59-24.33 38.75-38.95L427.67-895q12.63-6.67 25.45-10.17 12.82-3.5 26.72-3.5 13.89 0 27.05 3.64 13.17 3.64 25.44 10.03l283.34 163.33q25.16 14.62 39.08 38.95 13.92 24.33 13.92 52.05v187.34H763.33v-136.34l-282 166L196.67-589v269.33l303.33 175v120.34l-355.67-204q-24.5-15.29-38.41-39.15Q92-291.33 92-319.33Zm531.5 262.9q-56.83-56.44-56.83-136.5 0-80.07 56.83-136.9 56.83-56.84 136.5-56.84t136.5 56.75q56.83 56.74 56.83 137.25 0 79.96-56.83 136.32Q839.67 0 760 0T623.5-56.43ZM480-473.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestStatus);
export default __webpack_public_path__ + "static/media/requestStatus.df2afa2354d37037b83043880415d441.svg";
export { ForwardRef as ReactComponent };